import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=a1a9252a&scoped=true&"
import script from "./honor.vue?vue&type=script&lang=js&"
export * from "./honor.vue?vue&type=script&lang=js&"
import style0 from "./honor.vue?vue&type=style&index=0&id=a1a9252a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a9252a",
  null
  
)

export default component.exports